<template>
  <div class="d-flex flex-column align-items-center">
    <personal-signatory v-model="user.signer"  style="width: 40em;"/>
    <btn-action class="btn btn-primary" @click="save" >Сохранить</btn-action>
  </div>
</template>

<script>
  import PersonalSignatory from '../../components/personal/signatory.vue'
  import BtnAction from '../../components/btn-action'
  import api from '@/api'

  export default {
    components: {
      BtnAction,
      PersonalSignatory},
    data () {
      return {}
    },
    methods: {
      save () {
        return this.$validator.validateAll().then(success => {
          if (success) {
            return api.put(`region/${this.$root.user.region_id}`, this.user)
              .then(() => {
                this.$root.user.region.organization = this.user
              })
          }
        })
      },
    },
    computed: {
      user () {
        return this.$root.user.region.organization
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/personal/signatory.vue